import {Component, OnInit, input, OnChanges, SimpleChanges} from '@angular/core';
import {ButtonModule} from "primeng/button";
import {SelectModule} from "primeng/select";
import {InputTextModule} from "primeng/inputtext";
import {MultiSelectModule} from "primeng/multiselect";
import {ProgressBarModule} from "primeng/progressbar";
import {SharedModule} from "primeng/api";
import {SliderModule} from "primeng/slider";
import {TableModule} from "primeng/table";
import {OrderListModule} from "primeng/orderlist";
import {CheckboxModule} from "primeng/checkbox";
import {MenuModule} from "primeng/menu";
import {InplaceModule} from "primeng/inplace";
import {FormsModule} from "@angular/forms";

import {DataViewModule} from "primeng/dataview";
import {CardModule} from "primeng/card";
import {BlockUIModule} from "primeng/blockui";
import {SplitButtonModule} from "primeng/splitbutton";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {ToastModule} from "primeng/toast";
import {SkeletonModule} from "primeng/skeleton";
import {
    ProjectDescriptorCategoryComponent
} from "./project-descriptor-categories/category/project-descriptor-category.component";
import {ProjectDescriptorUse} from "../../api/enums";
import {ProjectDescriptorCategory, ProjectSchemaDisplay, ProjectSchemas} from "../../api/project_schemas";
import {Project} from "../../api/db/entities/Project";
import {ProjectProfileGroup} from "../../api/db/entities/ProjectProfileGroup";
@Component({
    selector: 'project-descriptor-panel',
    imports: [
    ButtonModule,
    SelectModule,
    InputTextModule,
    MultiSelectModule,
    ProgressBarModule,
    SharedModule,
    SliderModule,
    TableModule,
    OrderListModule,
    CheckboxModule,
    MenuModule,
    InplaceModule,
    FormsModule,
    DataViewModule,
    CardModule,
    BlockUIModule,
    SplitButtonModule,
    ConfirmDialogModule,
    ToastModule,
    SkeletonModule,
    ProjectDescriptorCategoryComponent
],
    templateUrl: './project-descriptor-panel.component.html',
    styleUrl: './project-descriptor-panel.component.scss'
})
export class ProjectDescriptorPanelComponent {
    readonly use = input.required<ProjectDescriptorUse>();
    readonly schemaDisplay = input.required<ProjectSchemaDisplay>();
    readonly profileGroup = input.required<ProjectProfileGroup>();

    constructor() {
    }

    ngOnInit() {
        console.log("PDC PANEL IS RUNNING");

    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['profileGroup']) {
            //console.log("PDC PANEL CHANGES CODE RUNNING");
            //console.log(this.profileGroup());
        }
    }

    protected readonly ProjectSchemas = ProjectSchemas;
}
